// src/scripts/sections/discount-code-bar-1.js
var DiscountCodeBar1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      clipboardCopyButton: "[js-clipboard-copy-button]",
      clipboardCopyText: "[js-clipboard-copy-text]"
    };
    this.attrs = {
      copySuccess: "data-copy-success",
      disabled: "disabled"
    };
    this.properties = {
      preCopyWidth: "--pre-copy-width",
      preCopyHeight: "--pre-copy-height"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.clipboardCopyButton = this.querySelector(
      this.selectors.clipboardCopyButton
    );
    this.clipboardCopyButton?.addEventListener(
      "click",
      (e) => this.handleClipboardCopyButtonClick(e),
      this.eventOptions
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  /**
   * Handles when the clipboard copy button is clicked.
   */
  handleClipboardCopyButtonClick() {
    this.lockClipboardCopyButton();
    const clipboardCopyText = this.querySelector(
      this.selectors.clipboardCopyText
    );
    navigator.clipboard.writeText(clipboardCopyText.textContent.trim()).then(
      () => this.clipboardCopyButton.setAttribute(this.attrs.copySuccess, true),
      (error) => console.error(error)
    );
    setTimeout(() => {
      this.clipboardCopyButton.setAttribute(this.attrs.copySuccess, false);
      this.unlockClipboardCopyButton();
    }, 1500);
  }
  /**
   * Locks the clipboard copy button to prevent spamming.
   * This includes keeping the button's current width and height in place.
   */
  lockClipboardCopyButton() {
    const preCopyWidth = this.clipboardCopyButton.clientWidth;
    const preCopyHeight = this.clipboardCopyButton.clientHeight;
    this.clipboardCopyButton.style.setProperty(
      this.properties.preCopyWidth,
      `${preCopyWidth}px`
    );
    this.clipboardCopyButton.style.setProperty(
      this.properties.preCopyHeight,
      `${preCopyHeight}px`
    );
    this.clipboardCopyButton.toggleAttribute(this.attrs.disabled);
  }
  /**
   * Unlocks the clipboard copy button, allowing button to resize again.
   */
  unlockClipboardCopyButton() {
    this.clipboardCopyButton.toggleAttribute(this.attrs.disabled);
    this.clipboardCopyButton.style.removeProperty(this.properties.preCopyWidth);
    this.clipboardCopyButton.style.removeProperty(this.properties.preCopyHeight);
  }
};
if (!customElements.get("fluco-local-v1-discount-code-bar-1")) {
  customElements.define("fluco-local-v1-discount-code-bar-1", DiscountCodeBar1);
}
